import React from "react"

export default function ContactPage() {
  return <h1>Contact Page</h1>
}
